<template>
    <v-dialog
        v-model="showDialog"
        width="600"
        :persistent="loading"
    >
        <v-card>
            <v-form
                ref="form"
                :disabled="loading"
                @submit.prevent="submitForm"
            >
                <v-card-title
                    style="background-color: #009688; color: white;"
                >
                    Edit Record
                </v-card-title>
                <v-card-text style="height: 70vh; overflow-x: hidden; overflow-y: scroll;">
                    <v-text-field
                        v-model="tempData.MSU_CODE"
                        :label="data.type === 'SINGLE' ? 'MSU Code' : 'MSU Group ID'"
                        disabled
                    />
                    <v-text-field
                        v-model="tempData.NAME"
                        :label="`${data.type === 'SINGLE' ? 'Hospital/Clinic Name' : 'Group Name' }`"
                        disabled
                    />
                    <v-text-field
                        v-model="tempData.PREFIX"
                        label="Prefix"
                        autocomplete="nope"
                    />
                    <v-text-field
                        v-model="tempData.FNAME"
                        label="First Name"
                        autocomplete="nope"
                    />
                    <v-text-field
                        v-model="tempData.SNAME"
                        label="Last Name"
                        autocomplete="nope"
                    />
                    <v-text-field
                        v-model="tempData.SUFFIX"
                        label="Suffix"
                        autocomplete="nope"
                    />
                    <v-text-field
                        v-model="tempData.DESIGNATION"
                        label="Designation"
                        autocomplete="nope"
                    />
                    <v-text-field
                        v-model="tempData.ACU_CONTACT_PERSON"
                        label="ACU Contact Person"
                        autocomplete="nope"
                    />
                    <v-text-field
                        v-model="tempData.ACU_CLINIC_TELNO"
                        label="ACU Contact No"
                        autocomplete="nope"
                    />
                    <v-textarea
                        v-model="tempData.ACU_SCHEDULE"
                        label="ACU Schedule"
                        autocomplete="nope"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        width="120"
                        :disabled="loading"
                        @click="showDialog = false"
                    >
                        <v-icon>{{ mdiClose }}</v-icon>
                        close
                    </v-btn>
                    <v-btn
                        color="teal darken-1"
                        width="120"
                        style="color: white;"
                        :loading="loading"
                        type="submit"
                    >
                        <v-icon>{{ mdiCheck }}</v-icon>
                        save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    mdiClose,
    mdiCheck
} from '@mdi/js'
export default {
    props: ['show', 'data', 'notif'],
    data: ()=>({
        mdiClose,
        mdiCheck,
        loading: false,
        tempData: {
            NAME: null,
            MSU_CODE: null,
            PREFIX: null,
            FNAME: null,
            SNAME: null,
            SUFFIX: null,
            DESIGNATION: null,
            ACU_CONTACT_PERSON: null,
            ACU_SCHEDULE: null,
            ACU_CLINIC_TELNO: null
        }
    }),
    computed: {
        ...mapGetters(['editProviderAcuInfoData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.resetForm()
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        editProviderAcuInfoData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Provider Acu Info has been updated.'
                    this.notif.show = true
                    this.showDialog = false
                    this.viewProviderAcuInfo({ MSU_C: this.tempData.MSU_CODE })
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
            this.loading = false
        },
        data: {
            handler(newVal) {
                if (newVal) {
                    this.tempData = structuredClone(newVal)
                    this.tempData.MSU_CODE = this.data.type === 'SINGLE' ? this.data.hosp_msu_code : this.data.group_id
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        ...mapActions(['editProviderAcuInfo', 'viewProviderAcuInfo']),
        resetForm() {
            if (this.$refs && this.$refs.form) {
                this.tempData = structuredClone(this.data)
                this.$refs.form.resetValidation()
            }
        },
        submitForm() {
            if (this.$refs && this.$refs.form && this.$refs.form.validate()) {
                this.loading = true
                this.tempData.MSU_C = this.tempData.MSU_CODE
                this.editProviderAcuInfo(this.tempData)
            }
        }
    }
}
</script>
